import React from "react";
import ContentPage, { Block, Steps } from "../components/ContentPage";

export default function VerlanglijstPage() {
  return (
    <ContentPage
      title="Laat de ontvanger zelf kiezen"
      lead="Het is niet altijd gemakkelijk om vanuit Europa te weten welke producten iemand in Suriname precies nodig heeft. Daarom kan de ontvanger een verlanglijst maken en deze met jou delen."
      ctaLabel="Maak een verlanglijst"
      secondaryLabel="Betaal een gedeelde verlanglijst"
    >
      <Block title="Zo werkt het">
        <Steps
          items={[
            {
              title: "De ontvanger kiest de gewenste producten",
              body: "In Suriname stelt iemand een verlanglijst samen met wat er nodig is.",
            },
            {
              title: "De verlanglijst wordt met jou gedeeld",
              body: "Jij ontvangt de lijst eenvoudig via de app of een deellink.",
            },
            {
              title: "Jij bekijkt en betaalt vanuit Europa",
              body: "Je houdt controle over het bedrag en ziet precies wat er besteld wordt.",
            },
            {
              title: "Wij bezorgen in Suriname",
              body: "De producten worden lokaal klaargemaakt en bij de ontvanger bezorgd.",
            },
          ]}
        />
        <p>
          Zo krijgt de ontvanger precies wat nodig is en houd jij controle over
          het bedrag dat wordt besteed.
        </p>
      </Block>
    </ContentPage>
  );
}
